import { useEffect } from "react";

// Auto-translate widget (Google). No API key required.
export const Translate = () => {
  useEffect(() => {
    if (document.getElementById("google-translate-script")) return;

    window.googleTranslateElementInit = () => {
      if (!window.google || !window.google.translate) return;
      new window.google.translate.TranslateElement(
        {
          pageLanguage: "en",
          includedLanguages:
            "es,fr,pt,de,it,ru,zh-CN,ja,ko,ar,he,sw,tl,hi,vi,id,nl,pl,ro,uk,el,am,ha,yo,zu",
          autoDisplay: false,
        },
        "google_translate_element"
      );
    };

    const s = document.createElement("script");
    s.id = "google-translate-script";
    s.src = "//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
    document.body.appendChild(s);
  }, []);

  return <div id="google_translate_element" data-testid="language-select" />;
};
